import { validateIsEmpty, validateName } from 'shared/entities/validator';
import { FieldModel } from 'shared/models/form';

import UserEditModel from './UserEditModel';

export default class RegisterEditModel extends UserEditModel {
  readonly name: FieldModel<string> = new FieldModel<string>('', [
    validateIsEmpty,
    validateName
  ]);

  readonly marketingConsent: FieldModel<boolean> = new FieldModel<boolean>(
    false
  );

  readonly termsAccepted: FieldModel<boolean> = new FieldModel<boolean>(false);

  get isError(): boolean {
    return (
      !!this.emailError ||
      this.password.isError ||
      this.name.isError ||
      !this.termsAccepted.value
    );
  }

  reset(): void {
    super.reset();

    this.name.reset();
    this.termsAccepted.changeValue(false);
    this.marketingConsent.changeValue(false);
  }

  resetErrors(): void {
    super.resetErrors();
    this.name.resetError();
  }

  validate(): void {
    super.validate();
    this.name.validate();
  }

  toJson(): {
    email: string;
    password: string;
    name: string;
    marketing_consent: boolean;
  } {
    return {
      ...super.toJson(),
      name: this.name.value.trim(),
      marketing_consent: this.marketingConsent.value
    };
  }
}
